module.exports = __webpack_public_path__ + "img/pic_ab_test_empty.acc548f4.png";